/* MK 01.10.2026 : textes traduits fournis par window.MK_I18N.c (layout/theme.liquid) ; anglais par défaut */
function mkT(k, d) { try { return (window.MK_I18N && window.MK_I18N.c && window.MK_I18N.c[k]) || d; } catch (e) { return d; } }
/* Destination: assets/loyalty-cart.js
 *
 * Lightweight client for the Loyalty Circle storefront routes exposed via the Shopify App
 * Proxy (see snippets/loyalty-cart-widget.liquid and templates/page.loyalty-dashboard.liquid).
 * All requests are same-origin (the browser calls maisonkargani.com/apps/..., Shopify
 * forwards server-side to the CRM Worker): no CORS to handle here.
 *
 * UX: a SINGLE "Use my points" toggle -- no quantity input. Turning the toggle on reserves
 * the FULL available balance and immediately applies the real generated discount code
 * (redirect to /discount/{code}, the only reliable way to apply a discount to the cart from
 * the storefront). The "active" state is then determined from real /cart.js data (source of
 * truth) on page load, not from an assumed local state.
 *
 * Project convention note: zero non-ASCII characters in this file (the Shopify assets
 * minifier crashes on unescaped accented characters -- see the project's technical memory).
 * Accented user-facing text (if any) should be written using JS unicode escapes (e.g. \u00e9),
 * which stay pure ASCII in the source code while rendering correctly once interpreted by
 * the browser.
 */
(function () {
  'use strict';

  // Guard against double execution if the <script> tag appears more than once on the same
  // page (e.g. widget present both in the cart drawer and on /cart).
  if (window.__karganiLoyaltyCartJsLoaded) return;
  window.__karganiLoyaltyCartJsLoaded = true;

  var STORAGE_PREFIX = 'kargani_loyalty_redemption_';
  var DISCOUNT_CODE_PREFIX = 'KARGANI-';

  function getProxyBase(el) {
    return (el && el.getAttribute('data-proxy-base')) || '/apps/kargani-crm';
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function parseJsonResponse(res) {
    return res
      .json()
      .catch(function () { return {}; })
      .then(function (data) {
        if (!res.ok) {
          var err = new Error((data && data.error) || 'Error ' + res.status);
          err.status = res.status;
          err.data = data;
          throw err;
        }
        return data;
      });
  }

  function apiGet(base, path) {
    return fetch(base + path, { headers: { Accept: 'application/json' } }).then(parseJsonResponse);
  }

  function apiPost(base, path, body) {
    return fetch(base + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {}),
    }).then(parseJsonResponse);
  }

  // Removes any discount code currently applied to the cart (native Shopify Ajax Cart
  // endpoint -- passing an empty string does clear the active codes list on this cart,
  // confirmed live: the only reliable way to "remove" a code applied via /discount/CODE
  // without going through checkout).
  function clearCartDiscount() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' }),
    }).then(function (res) { return res.json(); });
  }

    function formatChf(cents) {
    return Math.round(cents / 100) + ' CHF';
  }
  function reopenCartDrawerIfNeeded() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('loyalty_open') !== '1') return;
    params.delete('loyalty_open');
    var newSearch = params.toString();
    var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
    history.replaceState({}, '', newUrl);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  document.addEventListener('DOMContentLoaded', reopenCartDrawerIfNeeded);
  if (document.readyState !== 'loading') {
    reopenCartDrawerIfNeeded();
  }
  function getStored(cartToken) {
    try {
      var raw = sessionStorage.getItem(STORAGE_PREFIX + cartToken);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setStored(cartToken, value) {
    try {
      sessionStorage.setItem(STORAGE_PREFIX + cartToken, JSON.stringify(value));
    } catch (e) {
      /* storage unavailable (private browsing, quota): the reservation stays valid
         server-side, only the local reservation id lookup for cancellation won't persist. */
    }
  }

  function clearStored(cartToken) {
    try {
      sessionStorage.removeItem(STORAGE_PREFIX + cartToken);
    } catch (e) {}
  }

  // Looks for an already-active Kargani discount on the current cart, based on real
  // /cart.js data -- that's the source of truth (not sessionStorage, which is only used to
  // recover the reservation id to allow removal).
  function findActiveKarganiDiscount(cart) {
    var apps = cart.cart_level_discount_applications || [];
    var total = 0;
    var found = false;
    for (var i = 0; i < apps.length; i++) {
      var app = apps[i];
      if (app && typeof app.title === 'string' && app.title.indexOf(DISCOUNT_CODE_PREFIX) === 0) {
        found = true;
        total += app.total_allocated_amount || 0;
      }
    }
    return found ? { amountCents: total } : null;
  }

  // ---- Cart widget (loyalty-cart-widget.liquid) ----

  function initWidget(el) {
    if (el.getAttribute('data-kargani-loyalty-init') === '1') return;
    el.setAttribute('data-kargani-loyalty-init', '1');

    var balanceEl = el.querySelector('[data-kargani-loyalty-balance]');
    if (!balanceEl) return; // logged-out customer: nothing to initialize for this block

    var base = getProxyBase(el);
    var bodyEl = el.querySelector('[data-kargani-loyalty-body]');
    var toggleEl = el.querySelector('[data-kargani-loyalty-toggle]');
    var hintEl = el.querySelector('[data-kargani-loyalty-hint]');
    var breakdownEl = el.querySelector('[data-kargani-loyalty-breakdown]');
    var totalBeforeEl = el.querySelector('[data-kargani-loyalty-total-before]');
    var discountLabelEl = el.querySelector('[data-kargani-loyalty-discount-label]');
    var discountValueEl = el.querySelector('[data-kargani-loyalty-discount-value]');
    var totalAfterEl = el.querySelector('[data-kargani-loyalty-total-after]');
    var errorEl = el.querySelector('[data-kargani-loyalty-error]');

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function renderOff(availablePoints) {
      if (toggleEl) {
        toggleEl.checked = false;
        toggleEl.disabled = !availablePoints || availablePoints <= 0;
      }
      if (hintEl) {
        hintEl.textContent = availablePoints > 0
          ? mkT('s_3c50b0374843', "Available balance: %P% pts").replace('%P%', availablePoints)
          : mkT('s_2641f0e946c7', "No points available right now.");
      }
      if (breakdownEl) breakdownEl.hidden = true;
    }

    function renderOn(cart, redemption) {
      if (toggleEl) {
        toggleEl.checked = true;
        toggleEl.disabled = false;
      }
      var pointsUsed = redemption && redemption.points;
      if (hintEl) {
        hintEl.textContent = pointsUsed
          ? mkT('s_62fb9d62b902', "Points used: %P% pts").replace('%P%', pointsUsed)
          : mkT('s_792a830f9b8b', "Loyalty Circle points used on this order.");
      }
      if (breakdownEl) {
        var totalAfter = cart.total_price;
        var discountCents = (redemption && redemption.amountCents) || cart.total_discount || 0;
        var totalBefore = totalAfter + discountCents;
        if (totalBeforeEl) totalBeforeEl.textContent = formatChf(totalBefore);
        if (discountLabelEl) {
          discountLabelEl.textContent = pointsUsed
            ? mkT('s_fbd330dc682a', "Loyalty Circle privilege (-%P% pts)").replace('%P%', pointsUsed)
            : mkT('s_37ba37de8f2d', "Loyalty Circle privilege");
        }
        if (discountValueEl) discountValueEl.textContent = '-' + formatChf(discountCents);
        if (totalAfterEl) totalAfterEl.textContent = formatChf(totalAfter);
        breakdownEl.hidden = false;
      }
    }

    function refresh(cartToken) {
      Promise.all([fetchCart(), apiGet(base, '/loyalty/me')])
        .then(function (results) {
          var cart = results[0];
          var loyalty = results[1];

          if (balanceEl) balanceEl.textContent = loyalty.points + ' pts';
          if (bodyEl) bodyEl.hidden = false;

          var active = findActiveKarganiDiscount(cart);
          if (active) {
            var stored = getStored(cartToken);
            renderOn(cart, stored ? { id: stored.id, points: stored.points, amountCents: active.amountCents } : { amountCents: active.amountCents });
          } else {
            clearStored(cartToken);
            renderOff(loyalty.available_points);
          }
        })
        .catch(function () {
          showError(mkT('s_84765dcb096f', "Unable to load your Loyalty Circle balance right now."));
        });
    }

    fetchCart()
      .then(function (cart) {
        var cartToken = cart.token;
        el.setAttribute('data-cart-token', cartToken);
        refresh(cartToken);

        if (toggleEl) {
          toggleEl.addEventListener('change', function () {
            if (toggleEl.checked) {
              // ---- Activation: reserves the full available balance, then immediately
              // applies the code via redirect (the only reliable way to reflect the
              // discount in Shopify's displayed total).
              toggleEl.disabled = true;
              showError('');
              apiGet(base, '/loyalty/me')
                .then(function (loyalty) {
                  if (!loyalty.available_points || loyalty.available_points <= 0) {
                    showError(mkT('s_2641f0e946c7', "No points available right now."));
                    toggleEl.checked = false;
                    toggleEl.disabled = false;
                    return;
                  }
                  return apiPost(base, '/loyalty/redeem', {
                    cart_token: cartToken,
                    points: loyalty.available_points,
                  }).then(function (data) {
                    setStored(cartToken, {
                      id: data.id,
                      points: loyalty.available_points,
                      monetary_value_cents: data.monetary_value_cents,
                      discount_code: data.discount_code || null,
                    });
                    if (data.discount_code) {
                      fetch('/discount/' + encodeURIComponent(data.discount_code), { credentials: 'same-origin' })
                        .then(function () { refresh(cartToken); })
                        .catch(function () { refresh(cartToken); });
                      return; // discount appliqué en arrière-plan, refresh() met à jour le panier sans recharger la page
                    }
                    // Rare case: reservation created but code not generated (Admin API
                    // unavailable at reservation time) -- best-effort, never blocking on
                    // the worker-index.js createShopifyDiscountCode side.
                    showError(mkT('s_089e421805c1', "Your points are reserved but the discount could not be generated automatically. Contact us to have it applied to your order."));
                    toggleEl.checked = false;
                    toggleEl.disabled = false;
                  });
                })
                .catch(function (err) {
                  showError((err && err.data && err.data.error) || mkT('s_152d03729bf0', "Unable to use your points right now."));
                  toggleEl.checked = false;
                  toggleEl.disabled = false;
                });
            } else {
              // ---- Deactivation: removes the code from the cart (native Ajax Cart
              // endpoint, the only confirmed way to make the discount disappear from the
              // displayed total without going through checkout), THEN cancels the
              // reservation on the CRM side (releases the points, deactivates the code on
              // the Shopify side to prevent reuse).
              toggleEl.disabled = true;
              showError('');
              var stored = getStored(cartToken);
              clearCartDiscount()
                .then(function () {
                  return stored
                    ? apiPost(base, '/loyalty/redeem/' + stored.id + '/cancel', {}).catch(function () {})
                    : Promise.resolve();
                })
                .then(function () {
                  clearStored(cartToken);
                  refresh(cartToken);
                })
                .catch(function () {
                  showError(mkT('s_56a4d1e9ebd6', "Unable to remove the privilege right now."));
                  toggleEl.checked = true;
                  toggleEl.disabled = false;
                });
            }
          });
        }
      })
      .catch(function () {
        showError(mkT('s_0ffe6654bf2d', "Unable to load your cart right now."));
      });
  }

  function initAllWidgets() {
    var widgets = document.querySelectorAll('[data-kargani-loyalty-widget]');
    for (var i = 0; i < widgets.length; i++) initWidget(widgets[i]);
  }

  document.addEventListener('DOMContentLoaded', initAllWidgets);
  document.addEventListener('shopify:section:load', initAllWidgets);
  window.addEventListener('pageshow', initAllWidgets);
  if (document.readyState !== 'loading') initAllWidgets();

  // The cart drawer can be re-rendered via AJAX (cart-drawer.js) without triggering the
  // events above -- same pitfall already documented for fixCartSwatches() in the project's
  // technical memory. We observe #CartDrawer to reinitialize the widget.
  document.addEventListener('DOMContentLoaded', function () {
    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer && window.MutationObserver) {
      new MutationObserver(initAllWidgets).observe(cartDrawer, { childList: true, subtree: true });
    }
  });

  // Reusable client API, notably used by templates/page.loyalty-dashboard.liquid.
  window.KarganiLoyalty = {
    apiGet: apiGet,
    apiPost: apiPost,
    getProxyBase: getProxyBase,
    fetchCart: fetchCart,
    formatChf: formatChf,
  };
})();

/* 28.10.2026 : le bouton LOG IN du panier ramène, après connexion, à la page en cours avec le panier rouvert (?loyalty_open=1), jamais à l’adresse technique « ?sections=… » du rafraîchissement du panier. */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-mk-login-return]') : null;
    if (!a) return;
    try {
      var u = new URL(a.getAttribute('href'), window.location.origin);
      var p = window.location.pathname;
      var back = /\/cart\/?$/.test(p) ? p : p + '?loyalty_open=1';
      u.searchParams.set('return_to', back);
      a.setAttribute('href', u.pathname + u.search);
    } catch (err) {}
  }, true);
})();
